import React, { FC } from "react";
import styled from "styled-components";
import { GREEN } from "../styles/constants";

interface Props {
  center?: boolean;
  name?: string;
  showRecaptcha?: boolean;
}
const Policy: FC<Props> = ({
  name = "Оформить заказ",
  showRecaptcha,
  ...props
}) => {
  return (
    <PolicyEl {...props}>
      Нажимая "{name}", Вы даёте Согласие на обработку Ваших персональных данных
      и принимаете{" "}
      <a href="/privacy-policy" target="_blank">
        Пользовательское соглашение
      </a>
      <br />
      <br />
      {showRecaptcha && (
        <>
          Этот сайт защищен reCAPTCHA и Google{" "}
          <a
            href="https://policies.google.com/privacy"
            target="_blank"
            rel="noopener noreferrer"
          >
            Политика конфиденциальности
          </a>{" "}
          и{" "}
          <a
            href="https://policies.google.com/terms"
            target="_blank"
            rel="noopener noreferrer"
          >
            Условия использования
          </a>{" "}
          применяются.
        </>
      )}
    </PolicyEl>
  );
};

const PolicyEl = styled.p<Props>`
  color: #000;
  font-size: 0.625rem;
  text-align: ${({ center }) => (center ? "center" : "left")};
  line-height: 1.4;
  a {
    color: ${GREEN};
  }
`;

export default Policy;
